import React from 'react'
import { Content, PageBase, Panel, TopNav } from '@debbie/iris/dist/components/index.js'
import { useParams } from 'react-router'
import { ViewQueue } from './ViewQueue.js'

export const ViewQueuePage = (props: {}) => {
  const { id, itemId } = useParams<{ id: string; itemId: string }>()
  return (
    <>
      <TopNav />
      <ViewQueue id={id} itemId={itemId} />
    </>
  )
}
